import axiosInstance from '../utils/axiosInstance';
const API_URL = `${process.env.REACT_APP_API_URL}/api/clientportal/v1/profile`;






// SMS consent from the Profile checkbox. It goes to update_phone_no (the
// route's old name), but only the consent is sent: the mobile is where 2FA
// codes go, so only staff change it, from Teams.
export const saveSmsConsent = async (smsConsent) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/update_phone_no`, { smsConsent });
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  };
  
  // Change password API call
  export const changePassword = async (id, currentPassword, newPassword, confirmPassword) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/change_password`, {
        id,
        currentPassword,
        newPassword,
        confirmPassword,
      });
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  };
  
  // Fetch last login API call
  export const getLastLogin = async () => {
    try {
      const response = await axiosInstance.get(`${API_URL}/getLastLogin`);
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  };



  export const uploadProfilePicture = async (formData) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/profile_pic`, formData, {
        headers: {
          "Content-Type": "multipart/form-data", // Required for uploading files
         
        },
      });
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  };


  export const getProfilePictureBlob = async () => {
    try {
      const response = await axiosInstance.get(`${API_URL}/profile_pic`, {
     
        responseType: "blob",
      });
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  };



  export const getUserDetails = async () => {
    try {
      const response = await axiosInstance.get(`${API_URL}/getLUserDetails`);
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error.message;
    }
  };
















// ── Authenticator app (TOTP) enrolment ──────────────────────────────────────
// These live on the auth routes, not /profile, because that is where the rest
// of the two-factor endpoints are.
const AUTH_URL = `${process.env.REACT_APP_API_URL}/api/clientportal/v1/auth`;

export const getTotpStatus = async () => {
  const res = await axiosInstance.get(`${AUTH_URL}/2fa/totp/status`);
  return res.data;
};

// Mints a secret and returns the QR to scan. Nothing is enabled until a code
// confirms the scan worked.
export const setupTotp = async () => {
  const res = await axiosInstance.post(`${AUTH_URL}/2fa/totp/setup`, {});
  return res.data;
};

export const enableTotp = async (otp) => {
  const res = await axiosInstance.post(`${AUTH_URL}/2fa/totp/enable`, { otp });
  return res.data;
};


// ── Passkeys (WebAuthn) ─────────────────────────────────────────────────────
export const getPasskeyStatus = async () => {
  const res = await axiosInstance.get(`${AUTH_URL}/2fa/passkey/status`);
  return res.data;
};

// Returns the options the browser needs to create a credential.
export const passkeyRegisterBegin = async () => {
  const res = await axiosInstance.post(`${AUTH_URL}/2fa/passkey/register/begin`, {});
  return res.data;
};

// Hands the signed attestation back for verification and storage.
export const passkeyRegisterFinish = async (response, label) => {
  const res = await axiosInstance.post(`${AUTH_URL}/2fa/passkey/register/finish`, { response, label });
  return res.data;
};


// ── Text message (SMS) 2FA ──────────────────────────────────────────────────
// Sends a code to the number already on the client's record. Like the
// authenticator, nothing is enabled until a code confirms the channel works.
// There is no disable: only staff can turn a client's 2FA off, from Teams.
// smsConsent: true when the client ticked the consent box on the setup screen
// (needed when consent is not already on file).
export const smsSetup = async (smsConsent) => {
  const res = await axiosInstance.post(`${AUTH_URL}/2fa/sms/setup`, { smsConsent });
  return res.data;
};

export const smsEnable = async (otp) => {
  const res = await axiosInstance.post(`${AUTH_URL}/2fa/sms/enable`, { otp });
  return res.data;
};

